import { Queues } from '@/components/pages/Queues'

interface QueueConfigTabProps {
  locations: any[]
  services: any[]
  tenantId: string
  onRefresh: () => void
}

export function QueueConfigTab(props: QueueConfigTabProps) {
  // Pass locations and services to Queues component
  return <Queues locations={props.locations} services={props.services} onRefresh={props.onRefresh} />
}
